import { Enums } from '../common/enums'

import { OpDataList } from '../util'
import { OpOperator } from '../core'
import { OpMessageData } from './op-message-data'


export class OpMessage {
    //Properties
    public idMessage: number
    public idMessageType: number
    public idMessageState: number
    public idMessageParent: number
    public idOperatorSender: number
    public idOperatorReceiver: number
    public title: string
    public content: string
    public insertDate: Date

    public dataList: OpDataList<OpMessageData> = new OpDataList<OpMessageData>()
    public opState: Enums.OpChangeState
    //Properties end

    //#region Navigation properties

    // public messageType: OpMessageType
    // public messageState: OpMessageState
    // public operatorSender: OpOperator
    // public operatorReceiver: OpOperator
    //#endregion

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#region IJsonSerializer Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.idMessage = opObj.ID_MESSAGE
            this.idMessageType = opObj.ID_MESSAGE_TYPE
            this.idMessageState = opObj.ID_MESSAGE_STATE
            this.idMessageParent = opObj.ID_MESSAGE_PARENT
            this.idOperatorSender = opObj.ID_OPERATOR_SENDER
            this.idOperatorReceiver = opObj.ID_OPERATOR_RECEIVER
            this.title = opObj.TITLE
            this.content = opObj.CONTENT
            this.insertDate = opObj.INSERT_DATE

            if (opObj.Datalist != null) {
                this.dataList = new OpDataList<OpMessageData>(opObj.Datalist)
            }

            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_MESSAGE: this.idMessage,
            ID_MESSAGE_TYPE: this.idMessageType,
            ID_MESSAGE_STATE: this.idMessageState,
            ID_MESSAGE_PARENT: this.idMessageParent,
            ID_OPERATOR_SENDER: this.idOperatorSender,
            ID_OPERATOR_RECEIVER: this.idOperatorReceiver,
            TITLE: this.title,
            CONTENT: this.content,
            INSERT_DATE: this.insertDate,
            DataList: this.dataList.ToJSON(),

            OpState: this.opState
        }
    }

    //#endregion
}